var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "show-close": false,
        visible: _vm.contactDialogVisible,
        "before-close": _vm.handleClose,
        center: "",
        "custom-class": "contact-dialog",
        title: "",
        width: "100%",
        fullscreen: ""
      },
      on: {
        "update:visible": function($event) {
          _vm.contactDialogVisible = $event
        },
        close: _vm.onDialogClose
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("div", { staticClass: "contact-title" }, [
                _vm._v("\n      Contact agent\n      "),
                _c(
                  "div",
                  { staticClass: "icon", on: { click: _vm.handleClose } },
                  [_c("i", { staticClass: "el-icon-close" })]
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "font-family": "DINosaur-a, sans-serif" },
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
                "label-width": "100px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50", placeholder: "Your name" },
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Email", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "100", placeholder: "Your email" },
                    model: {
                      value: _vm.form.email,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Phone number", prop: "phoneNumber" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "20",
                      placeholder: "Your phone number"
                    },
                    model: {
                      value: _vm.form.phoneNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "phoneNumber", $$v)
                      },
                      expression: "form.phoneNumber"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "option-item-group" },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.contactOptionChange },
                      model: {
                        value: _vm.form.actions,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "actions", $$v)
                        },
                        expression: "form.actions"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          key: "MAKE_APPOINTMENT",
                          attrs: { label: "MAKE_APPOINTMENT" }
                        },
                        [_vm._v("Make an appointment")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        { key: "CALL_BACK", attrs: { label: "CALL_BACK" } },
                        [_vm._v("Request a call back")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        { key: "SEND_EMAIL", attrs: { label: "SEND_EMAIL" } },
                        [_vm._v("Send me an email")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Message", prop: "message" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "1000",
                      placeholder: "Message"
                    },
                    model: {
                      value: _vm.form.message,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "message", $$v)
                      },
                      expression: "form.message"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "submit-button",
                      on: {
                        click: function($event) {
                          return _vm.onSubmit("form")
                        }
                      }
                    },
                    [
                      _vm._v("Confirm\n          "),
                      _vm.loading
                        ? _c("i", { staticClass: "el-icon-loading" })
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f117eb1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f117eb1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/contactAgentDialog.vue
// module id = null
// module chunks = 